module.exports = __webpack_public_path__ + "static/fonts/pingfangregular.5bd6da0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/pingfangregular.otf
// module id = dEMh
// module chunks = 1